const src = 'https://www.paypalobjects.com/api/checkout.js';

export default src;
